import { render, staticRenderFns } from "./CostPerUseInLocalCurrency.vue?vue&type=template&id=56f3b839&"
import script from "./CostPerUseInLocalCurrency.vue?vue&type=script&lang=js&"
export * from "./CostPerUseInLocalCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports